import React, { useState, useEffect } from "react";
import { Form, Modal, Button, InputGroup } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import { Link, useHistory } from "react-router-dom";
// import Avatar from 'avataaars';
import NavBar from "./NavBar";
import { useAlert } from "react-alert";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import MaleIcon from "../assets/images/MaleIcon.svg";
import FemaleIcon from "../assets/images/FemaleIcon.svg";
import Radio from "@mui/material/Radio";
import NavBarNew from "./NavBarNew";

const getCurrentDate = () => {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  // Format the date as 'YYYY-MM-DDTHH:MM'
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const HomePage = () => {
  const history = useHistory();
  const alert = useAlert();

  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("Male");
  const [refBy, setRefBy] = useState("");
  const [vidNo, setVidNo] = useState("");
  const [registeredDate, setRegisteredDate] = useState("");
  const [collectionDate, setCollectionDate] = useState(getCurrentDate());
  const [recievedDate, setRecievedDate] = useState("");
  const [reportedDate, setReportedDate] = useState("");
  const [aadharOrPassportDetails, setAadharOrPassportDetails] = useState("");
  const [centerName, setCenterName] = useState("");
  const [sampleId, setSampleId] = useState("");
  const [refCustomer, setRefCustomer] = useState("");

  const [employeeId, setEmployeeId] = useState("");

  const [department, setDepartment] = useState("");

  const [timeStampOfRegisteredDate, setTimeStampOfRegisteredDate] =
    useState("");
  const [timeStampOfCollectionDate, setTimeStampOfCollectionDate] =
    useState("");
  const [timeStampOfRecievedDate, setTimeStampOfRecievedDate] = useState("");
  const [timeStampOfReportedDate, setTimeStampOfReportedDate] = useState("");

  const [patientDetails, setPatientDetails] = useState("");
  const [nextPage, setNextPage] = useState(true);
  const [toggleGender, setToggleGender] = useState(false);
  const [toggleAvatar, setToggleAvatar] = useState(false);
  const [count, setCount] = useState(0);
  const [valueForAvatar, setValueForAvatar] = useState(0);
  const [updatedFields, setUpdatedFields] = useState([]);

  const clotheList = [
    "Hoodie",
    "BlazerShirt",
    "BlazerSweater",
    "CollarSweater",
    "GraphicShirt",
    "ShirtVNeck",
  ];

  const accessoriesTypeList = [
    "Sunglasses",
    "Blank",
    "Kurt",
    "Prescription01",
    "Prescription02",
    "Round",
  ];

  // modal state and functions
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const data = localStorage.getItem("patientDetails");
    const data2 = localStorage.getItem("valueForAvatar");
    if (data) {
      setPatientDetails(JSON.parse(data));
      const mydata = JSON.parse(data);

      setGender(mydata.gender);
      setName(mydata.name);
      setAge(mydata.age);
      setCollectionDate(mydata.collectionDate);
      setSampleId(mydata.sampleId);
    }
    if (data2) {
      setValueForAvatar(JSON.parse(data2));
    }
  }, []);

  useEffect(() => {
    const loginData = localStorage.getItem("credentials");
    if (JSON.parse(loginData)) {
      //
    } else {
      history.push("/login");
    }
  }, []);

  useEffect(() => {
    if (patientDetails) {
      localStorage.setItem("patientDetails", JSON.stringify(patientDetails));
    }

    localStorage.setItem("valueForAvatar", JSON.stringify(valueForAvatar));
    patientDetails && patientDetails.gender === "Female"
      ? localStorage.setItem(
          "getDataFrom",
          JSON.stringify("completePackageDataForFemale")
        )
      : localStorage.setItem(
          "getDataFrom",
          JSON.stringify("completePackageData")
        );
  });

  const submitHandler = (e) => {
    e.preventDefault();
    setToggleGender(false);
    console.log("pddpd", name, age, gender, collectionDate, sampleId);
    if (
      name !== "" &&
      age !== "" &&
      gender !== "" &&
      collectionDate !== "" &&
      sampleId !== ""
    ) {
      setPatientDetails({
        name: updatedFields.includes("name") ? name : patientDetails.name,
        age: updatedFields.includes("age") ? age : patientDetails.age,
        gender:
          gender || updatedFields.includes("gender")
            ? gender
            : patientDetails.gender,
        refBy: updatedFields.includes("refBy") ? refBy : patientDetails.refBy,
        registeredDate: updatedFields.includes("registeredDate")
          ? registeredDate
          : patientDetails.registeredDate,
        collectionDate:
          collectionDate || updatedFields.includes("collectionDate")
            ? collectionDate
            : patientDetails.collectionDate,
        reportedDate: updatedFields.includes("reportedDate")
          ? reportedDate
          : patientDetails.reportedDate,
        timeStampOfRegisteredDate: updatedFields.includes(
          "timeStampOfRegisteredDate"
        )
          ? timeStampOfRegisteredDate
          : patientDetails.timeStampOfRegisteredDate,
        timeStampOfCollectionDate: updatedFields.includes(
          "timeStampOfCollectionDate"
        )
          ? timeStampOfCollectionDate
          : patientDetails.timeStampOfCollectionDate,
        timeStampOfReportedDate: updatedFields.includes(
          "timeStampOfReportedDate"
        )
          ? timeStampOfReportedDate
          : patientDetails.timeStampOfReportedDate,
        centerName: updatedFields.includes("centerName")
          ? centerName
          : patientDetails.centerName,
        sampleId: updatedFields.includes("sampleId")
          ? sampleId
          : patientDetails.sampleId,
        refCustomer: updatedFields.includes("refCustomer")
          ? refCustomer
          : patientDetails.refCustomer,
        employeeId: updatedFields.includes("employeeId")
          ? employeeId
          : patientDetails.employeeId,
        department: updatedFields.includes("department")
          ? department
          : patientDetails.department,
      });
      //localStorage.setItem("patientDetails", JSON.stringify(patientDetails));
      setNextPage(false);
    } else {
      alert.error("Fill all necessary Fields marked with *");
    }
  };

  console.log("registeredDate is: ", registeredDate);

  // updating dates logic
  const addAmPmLogic = (dateValue, dateType) => {
    if (dateType === "registeredDate") {
      let modify1 = registeredDate
        ? registeredDate.slice(0, 17) + ` ${dateValue})`
        : patientDetails && patientDetails.registeredDate !== undefined
        ? patientDetails.registeredDate.slice(0, 17) + ` ${dateValue})`
        : "";
      setRegisteredDate(modify1);
      patientDetails.registeredDate = modify1;
      setPatientDetails(patientDetails);
    } else if (dateType === "collectionDate") {
      let modify1 = collectionDate
        ? collectionDate.slice(0, 17) + ` ${dateValue})`
        : patientDetails && patientDetails.collectionDate !== undefined
        ? patientDetails.collectionDate.slice(0, 17) + ` ${dateValue})`
        : "";
      setCollectionDate(modify1);
      patientDetails.collectionDate = modify1;
      setPatientDetails(patientDetails);
    } else if (dateType === "recievedDate") {
      let modify1 = recievedDate
        ? recievedDate.slice(0, 17) + ` ${dateValue})`
        : patientDetails && patientDetails.recievedDate !== undefined
        ? patientDetails.recievedDate.slice(0, 17) + ` ${dateValue})`
        : "";
      setRecievedDate(modify1);
      patientDetails.recievedDate = modify1;
      setPatientDetails(patientDetails);
    } else if (dateType === "reportedDate") {
      let modify1 = reportedDate
        ? reportedDate.slice(0, 17) + ` ${dateValue})`
        : patientDetails && patientDetails.reportedDate !== undefined
        ? patientDetails.reportedDate.slice(0, 17) + ` ${dateValue})`
        : "";
      setReportedDate(modify1);
      patientDetails.reportedDate = modify1;
      setPatientDetails(patientDetails);
    }
  };

  const randomAvatarHandler = () => {
    setToggleAvatar(true);
    if (count > 5) {
      setCount(0);
    } else {
      setCount(count + 1);
    }
  };

  const resetDataHandler = () => {
    setPatientDetails({
      name: "",
      age: "",
      gender: "",
      sampleId: "",
      refBy: "",
      centerName: "",
      refCustomer: "",
      registeredDate: "",
      collectionDate: "",
      reportedDate: "",
      employeeId: "",
      department: "",
    });
    localStorage.removeItem("valueForAvatar");
    localStorage.removeItem("page1Data");
    localStorage.removeItem("currentTestData");
    handleClose();
    window.location.reload();
  };

  const dateHandler1 = (theDate) => {
    setRegisteredDate(theDate);
  };

  const dateHandler2 = (theDate) => {
    setCollectionDate(theDate);
  };

  const dateHandler4 = (theDate) => {
    setReportedDate(theDate);
  };

  const centers = [
    { key: 0, text: "prolabs", value: "Prolabs" },
    { key: 1, text: "Neuburg", value: "Neuburg" },
    { key: 2, text: "Bharath Kempanna", value: "Bharath Kempanna" },
  ];

  console.log("gender", gender, patientDetails, collectionDate);
  console.log("collectionDate", collectionDate);

  return (
    <>
      <NavBarNew />
      <div className="container-fluid" style={{ padding: "40px 8%" }}>
        <div className="card">
          {/* Modal Start*/}
          <div>
            <>
              <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                  <Modal.Title>
                    <i
                      style={{ color: "#e6e600" }}
                      className="fas fa-exclamation-triangle"
                    ></i>{" "}
                    Reset Confirmation
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Resetting your patient information will erase all the data of
                  the patient, including their tests. Are you sure you want to
                  continue?
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="danger btn-sm" onClick={resetDataHandler}>
                    Confirm Reset
                  </Button>
                  <Button variant="primary btn-sm" onClick={handleClose}>
                    Cancel
                  </Button>
                </Modal.Footer>
              </Modal>
            </>
          </div>

          {/* Modal End */}
          <Stack direction="row" alignItems="center" sx={{ flexWrap: "wrap" }}>
            <Box
              flexGrow={1}
              p={5}
              alignSelf="stretch"
              sx={{
                borderRight: "1px solid rgba(0, 0, 0, 0.2)",
                background: "rgba(244, 247, 252, 0.75)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {gender === "Female" ? (
                <div>
                  <img src={FemaleIcon} alt="female" />
                </div>
              ) : (
                <div>
                  <img src={MaleIcon} alt="male" />
                </div>
              )}

              <Stack
                mt={3}
                direction="row"
                alignItems="center"
                gap={5}
                justifyContent="center"
                sx={{ display: "none" }}
              >
                <button
                  title="change"
                  className="btn btn-primary btn-sm button-focus-css mx-1"
                  style={{ width: "40px" }}
                  onClick={() => {
                    randomAvatarHandler();
                    setValueForAvatar(count);
                  }}
                >
                  <i className="fas fa-exchange-alt"></i>
                </button>

                <button
                  title="default"
                  className="btn btn-primary btn-sm button-focus-css mx-1"
                  style={{ width: "40px" }}
                  onClick={() => {
                    setToggleAvatar(false);
                    setValueForAvatar(0);
                  }}
                >
                  <i className="fas fa-undo-alt"></i>
                </button>
              </Stack>
            </Box>
            <Box p={4} flexGrow={6}>
              <Form onChange={() => setNextPage(true)} onSubmit={submitHandler}>
                <div className="row">
                  <Form.Group className="col-6 mb-3">
                    <Form.Label>
                      <b>Patient's Name*</b>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter name"
                      defaultValue={patientDetails ? patientDetails.name : name}
                      onChange={(e) => {
                        setName(e.target.value);
                        setUpdatedFields([...updatedFields, "name"]);
                      }}
                      style={{ background: "#F7FBFF", borderRadius: "12px" }}
                    />
                  </Form.Group>

                  <Form.Group className="col-2 mb-3">
                    <Form.Label>
                      <b>Age*</b>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter age"
                      defaultValue={patientDetails ? patientDetails.age : age}
                      onChange={(e) => {
                        setAge(e.target.value);
                        setUpdatedFields([...updatedFields, "age"]);
                      }}
                      style={{ background: "#F7FBFF", borderRadius: "12px" }}
                    />
                  </Form.Group>

                  {/* <Form.Group controlId="Radiogender" className="col mb-3">
                    <Form.Label>
                      <b>Gender*</b>
                    </Form.Label>
                    <span style={{ display: "flex" }}>
                      <span style={{ marginTop: "5px" }}>Male</span>
                      <span
                        style={{
                          display: "flex",
                          marginLeft: "-15px",
                          marginRight: "22px",
                          marginTop: "5px",
                        }}
                      >
                        <span>
                          <Form.Check id="radioMale">
                            <Form.Check
                              name="gender"
                              value={gender}
                              type="radio"
                              checked={gender === "Male" || true}
                              onChange={() => {
                                setGender("Male");
                                setUpdatedFields([...updatedFields, "gender"]);
                              }}
                            />
                          </Form.Check>
                        </span>
                      </span>

                      <span style={{ marginTop: "5px" }}>Female</span>
                      <span
                        style={{
                          display: "flex",
                          marginLeft: "-15px",
                          marginTop: "5px",
                        }}
                      >
                        <span>
                          <Form.Check id="radioFemale">
                            <Form.Check
                              name="gender"
                              // defaultValue={gender}
                              type="radio"
                              // checked={gender === "Female"}
                              onChange={() => {
                                setGender("Female");
                                setUpdatedFields([...updatedFields, "gender"]);
                              }}
                            />
                          </Form.Check>
                        </span>
                      </span>
                    </span>
                  </Form.Group> */}

                  {/* choose gender */}

                  <FormControl className="col-4 mb-3">
                    <FormLabel
                      id="demo-controlled-radio-buttons-group"
                      sx={{ color: "#000000", fontWeight: "bolder" }}
                    >
                      Gender*
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={gender}
                      onChange={(e) => {
                        setGender(e.target.value);
                        setUpdatedFields([...updatedFields, "gender"]);
                      }}
                      sx={{ flexDirection: "row", marginTop: "5px" }}
                    >
                      <FormControlLabel
                        value="Male"
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 16,
                              },
                            }}
                          />
                        }
                        label="Male"
                        labelPlacement="start"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                            color: "#000000",
                          },
                        }}
                      />
                      <FormControlLabel
                        value="Female"
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 16,
                              },
                            }}
                          />
                        }
                        label="Female"
                        labelPlacement="start"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "14px",
                            color: "#000000",
                          },
                        }}
                      />
                    </RadioGroup>
                  </FormControl>

                  {/* <Box>
                    <Typography variant="body6">Gender*</Typography>
                    <RadioGroup
                      row
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      defaultValue="Male"
                      onChange={(e) => {
                        setGender(e.target.value);
                        setUpdatedFields([...updatedFields, "gender"]);
                      }}
                    >
                      <FormControlLabel
                        value="Male"
                        control={<Radio size="small" />}
                        label={<span style={{ fontSize: "15px" }}>Male</span>}
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Female"
                        control={<Radio size="small" />}
                        label={<span style={{ fontSize: "15px" }}>Female</span>}
                        labelPlacement="end"
                      />
                    </RadioGroup>
                  </Box> */}

                  {/* <Form.Group className="col mb-3">
            <Form.Label>
              <b>VID No: / UHID</b>
            </Form.Label>
            <InputGroup>
              <Form.Control
                type="number"
                placeholder="vid no"
                pattern="[0-9]+"
                defaultValue={patientDetails ? patientDetails.vidNo : vidNo}
                onChange={(e) => {
                  setVidNo(e.target.value)
                  setUpdatedFields([...updatedFields, "vidNo"])
                }}
              />
              <InputGroup.Text>{"/ HEALTH AVENUE"}</InputGroup.Text>
            </InputGroup>
          </Form.Group> */}
                </div>

                <div className="row">
                  <Form.Group className="col mb-3">
                    <Form.Label>
                      <b>{"Lab No*"}</b>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Lab No."
                      defaultValue={
                        patientDetails ? patientDetails.sampleId : sampleId
                      }
                      onChange={(e) => {
                        setSampleId(e.target.value);
                        setUpdatedFields([...updatedFields, "sampleId"]);
                      }}
                      style={{ background: "#F7FBFF", borderRadius: "12px" }}
                    />
                  </Form.Group>
                  <Form.Group className="col mb-3">
                    <Form.Label>
                      <b>Collection Date*</b>
                    </Form.Label>
                    <div className="d-flex">
                      <Form.Control
                        type="datetime-local"
                        placeholder="name"
                        defaultValue={
                          patientDetails?.collectionDate || collectionDate
                        }
                        onChange={(e) => {
                          dateHandler2(e.target.value);
                          setUpdatedFields([
                            ...updatedFields,
                            "collectionDate",
                          ]);
                        }}
                        style={{ background: "#F7FBFF", borderRadius: "12px" }}
                      />
                      <select
                        style={{
                          width: "50px",
                          background: "#F7FBFF",
                          borderRadius: "12px",
                        }}
                        onChange={(e) => {
                          setTimeStampOfCollectionDate(e.target.value);
                          setUpdatedFields([
                            ...updatedFields,
                            "timeStampOfCollectionDate",
                          ]);
                        }}
                        className="form-control"
                      >
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfCollectionDate === ""
                          }
                          value={""}
                        >
                          -- --
                        </option>
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfCollectionDate === "am"
                          }
                          value={"am"}
                        >
                          AM
                        </option>
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfCollectionDate === "pm"
                          }
                          value={"pm"}
                        >
                          PM
                        </option>
                      </select>
                    </div>
                  </Form.Group>
                  {/* <Form.Group className="col mb-3">
                    <Form.Label>
                      <b>Referred Dr.</b>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="refBy"
                      defaultValue={
                        patientDetails ? patientDetails.refBy : refBy
                      }
                      onChange={(e) => {
                        setRefBy(e.target.value);
                        setUpdatedFields([...updatedFields, "refBy"]);
                      }}
                    />
                  </Form.Group> */}

                  {/* <Form.Group className='col mb-3'>
            <Form.Label>
              <b>Center</b>
            </Form.Label>
            <Dropdown
              placeholder={
                patientDetails ? patientDetails.centerName : 'Select Center'
              }
              fluid
              selection
              options={centers}
              onChange={(e, data) => {
                setCenterName(data.value);
                setUpdatedFields([...updatedFields, 'centerName']);
              }}
            />
          </Form.Group> */}
                </div>

                {/* <div className="row">
          <Form.Group className="col mb-3">
            <Form.Label>
              <b>Aadhar / Passport Details</b>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="details"
              defaultValue={patientDetails ? patientDetails.aadharOrPassportDetails : aadharOrPassportDetails}
              onChange={(e) => {
                setAadharOrPassportDetails(e.target.value)
                setUpdatedFields([...updatedFields, "aadharOrPassportDetails"])
              }}
            />
          </Form.Group>
        </div> */}
                <div className="row">
                  {/* <Form.Group className="col mb-3">
                    <Form.Label>
                      <b>Ref Customer</b>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="ref customer"
                      defaultValue={
                        patientDetails
                          ? patientDetails.refCustomer
                          : refCustomer
                      }
                      onChange={(e) => {
                        setRefCustomer(e.target.value);
                        setUpdatedFields([...updatedFields, "refCustomer"]);
                      }}
                    />
                  </Form.Group> */}
                  {/* <Form.Group className="col mb-3">
                    <Form.Label>
                      <b>Employee ID</b>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Employee ID"
                      defaultValue={
                        patientDetails ? patientDetails.employeeId : employeeId
                      }
                      onChange={(e) => {
                        setEmployeeId(e.target.value);
                        setUpdatedFields([...updatedFields, "employeeId"]);
                      }}
                    />
                  </Form.Group> */}
                  {/* <Form.Group className="col mb-3">
                    <Form.Label>
                      <b>Department</b>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Department"
                      defaultValue={
                        patientDetails ? patientDetails.department : department
                      }
                      onChange={(e) => {
                        setDepartment(e.target.value);
                        setUpdatedFields([...updatedFields, "department"]);
                      }}
                    />
                  </Form.Group> */}
                </div>

                <div className="row">
                  {/* <Form.Group className="col mb-3">
                    <Form.Label>
                      <b>Registered Date</b>
                    </Form.Label>
                    <div className="d-flex">
                      <Form.Control
                        type="datetime-local"
                        placeholder=""
                        defaultValue={
                          patientDetails
                            ? patientDetails.registeredDate
                            : registeredDate
                        }
                        onChange={(e) => {
                          dateHandler1(e.target.value);
                          setUpdatedFields([
                            ...updatedFields,
                            "registeredDate",
                          ]);
                        }}
                      />
                      <select
                        style={{ width: "50px" }}
                        onChange={(e) => {
                          setTimeStampOfRegisteredDate(e.target.value);
                          setUpdatedFields([
                            ...updatedFields,
                            "timeStampOfRegisteredDate",
                          ]);
                        }}
                        className="form-control"
                      >
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfRegisteredDate === ""
                          }
                          value={""}
                        >
                          -- --
                        </option>
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfRegisteredDate === "am"
                          }
                          value={"am"}
                        >
                          AM
                        </option>
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfRegisteredDate === "pm"
                          }
                          value={"pm"}
                        >
                          PM
                        </option>
                      </select>
                    </div>
                  </Form.Group> */}

                  {/* <Form.Group className="col mb-3">
                    <Form.Label>
                      <b>Collection Date*</b>
                    </Form.Label>
                    <div className="d-flex">
                      <Form.Control
                        type="datetime-local"
                        placeholder="name"
                        defaultValue={
                          patientDetails
                            ? patientDetails.collectionDate
                            : collectionDate
                        }
                        onChange={(e) => {
                          dateHandler2(e.target.value);
                          setUpdatedFields([
                            ...updatedFields,
                            "collectionDate",
                          ]);
                        }}
                      />
                      <select
                        style={{ width: "50px" }}
                        onChange={(e) => {
                          setTimeStampOfCollectionDate(e.target.value);
                          setUpdatedFields([
                            ...updatedFields,
                            "timeStampOfCollectionDate",
                          ]);
                        }}
                        className="form-control"
                      >
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfCollectionDate === ""
                          }
                          value={""}
                        >
                          -- --
                        </option>
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfCollectionDate === "am"
                          }
                          value={"am"}
                        >
                          AM
                        </option>
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfCollectionDate === "pm"
                          }
                          value={"pm"}
                        >
                          PM
                        </option>
                      </select>
                    </div>
                  </Form.Group> */}

                  {/* <Form.Group className="col mb-3">
            <Form.Label>
              <b>Recieved Date</b>
            </Form.Label>
            <div className="d-flex">
              <Form.Control
                type="datetime-local"
                placeholder="name"
                defaultValue={patientDetails ? patientDetails.recievedDate : recievedDate}
                onChange={(e) => {
                  dateHandler3(e.target.value)
                  setUpdatedFields([...updatedFields, "recievedDate"])
                }}
              />
              <select style={{ width: "50px"}} onChange={(e) => {
                setTimeStampOfRecievedDate(e.target.value)
                setUpdatedFields([...updatedFields, "timeStampOfRecievedDate"])
              }} className="form-control">
                <option selected={patientDetails && patientDetails.timeStampOfRecievedDate === ""} value={""}>-- --</option>
                <option selected={patientDetails && patientDetails.timeStampOfRecievedDate === "am"} value={"am"}>AM</option>
                <option selected={patientDetails && patientDetails.timeStampOfRecievedDate === "pm"} value={"pm"}>PM</option>
              </select>
            </div>
          </Form.Group> */}

                  {/* <Form.Group className="col mb-3">
                    <Form.Label>
                      <b>Reported Date</b>
                    </Form.Label>
                    <div className="d-flex">
                      <Form.Control
                        type="datetime-local"
                        placeholder="name"
                        defaultValue={
                          patientDetails
                            ? patientDetails.reportedDate
                            : reportedDate
                        }
                        onChange={(e) => {
                          dateHandler4(e.target.value);
                          setUpdatedFields([...updatedFields, "reportedDate"]);
                        }}
                      />
                      <select
                        style={{ width: "50px" }}
                        onChange={(e) => {
                          setTimeStampOfReportedDate(e.target.value);
                          setUpdatedFields([
                            ...updatedFields,
                            "timeStampOfReportedDate",
                          ]);
                        }}
                        className="form-control"
                      >
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfReportedDate === ""
                          }
                          value={""}
                        >
                          -- --
                        </option>
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfReportedDate === "am"
                          }
                          value={"am"}
                        >
                          AM
                        </option>
                        <option
                          selected={
                            patientDetails &&
                            patientDetails.timeStampOfReportedDate === "pm"
                          }
                          value={"pm"}
                        >
                          PM
                        </option>
                      </select>
                    </div>
                  </Form.Group> */}
                </div>

                <Link
                  className="button-float-css"
                  to={"/itemSelection/"}
                  style={{ pointerEvents: nextPage === true ? "none" : "" }}
                >
                  <button
                    disabled={nextPage === true}
                    className="btn btn-outline-primary btn-sm mt-3"
                    style={{ borderRadius: "12px", width: "140px" }}
                  >
                    Next Page <i className="fas fa-arrow-alt-circle-right"></i>
                  </button>
                </Link>

                <Button
                  type="submit"
                  className="button-float-css btn btn-primary btn-sm mx-2 mt-3"
                  style={{ borderRadius: "12px", width: "140px" }}
                >
                  Save
                </Button>

                <button
                  onClick={handleShow}
                  className="btn btn-outline-danger btn-sm mt-3 button-focus-css"
                  style={{ borderRadius: "12px", width: "140px" }}
                >
                  <i className="fas fa-undo-alt"></i> Reset User
                </button>
              </Form>
            </Box>
          </Stack>
        </div>
      </div>
    </>
  );
};

export default HomePage;
